import { Zap, Sparkles, LayoutTemplate, type LucideIcon } from "lucide-react";

export interface CreateMenuItem {
  /** i18n key under nav:create.* — label is `create.<key>`, description `create.<key>Desc`. */
  key: "quickPost" | "compose" | "template";
  href: string;
  icon: LucideIcon;
}

/** The content-creation entry points, in recommended order. Pure so it's unit-testable. */
export function createMenuItems(brandSlug: string): CreateMenuItem[] {
  return [
    { key: "quickPost", href: `/${brandSlug}/quick-post`, icon: Zap },
    { key: "compose", href: `/${brandSlug}/compose`, icon: Sparkles },
    { key: "template", href: `/${brandSlug}/quick-post-pro`, icon: LayoutTemplate },
  ];
}
